<template>
  <vue-accessible-modal @close="nextPrompt">
    <template v-slot:backdrop />
  </vue-accessible-modal>
</template>

<script>
import PromptsClient from '@/api/PromptsClient'
import CreditExplanationModal from './credit-explanation.vue'
import CampusPoliciesModal from './campus-policies.vue'
import SmsCommunicationOutageModal from './sms-communication-outage.vue'
import LocationUpdateRequestModal from './location-update-request.vue'

export default {
  data() {
    return {
      client: new PromptsClient(this.$http),

      current: null,
      requested: null,
      prompts: [
        // In order you want them to show.
        SmsCommunicationOutageModal,
        CreditExplanationModal,
        CampusPoliciesModal,
        LocationUpdateRequestModal
      ]
    }
  },
  async mounted() {
    try {
      this.requested = await this.client.getPrompts(this.$store.getters.currentUser.id);
    } catch (ex) {
      console.error(ex);
      this.requested = [];
    }
    this.nextPrompt();
  },
  methods: {
    async nextPrompt() {
      if (this.current) {
        await this.client.completePrompts(this.$store.getters.currentUser.id, this.current);
      }

      for (const modal of this.prompts){
        for (let i = 0; i < this.requested.length; i++) {
          if (modal.name == this.requested[i]) {
            this.current = this.requested[i];
            this.requested.splice(i, 1);
            this.$modal.show(modal);
            return;
          }
        }
      }
    },
  }
}
</script>

<style>

</style>
